import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import { PDFViewer } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import scheduleService from "services/report/scheduleService";

import STDocument from "../cetak/STDocument";
import STskp from "views/cetak/STskp";
import STInspeksi from "views/cetak/STInspeksi";

// import SPPDDepan from "./SPPDdepan";
// import SPPD from "./SPPD";

const CetakST = ({ isOpen, onClose, sourceId, docType }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isOpen || !sourceId) return;
    const load = async () => {
      const res = await scheduleService.getJadwalByIdSurat(sourceId);
      setData(res.data);
    };
    load();
  }, [isOpen, sourceId]);

  if (!data) return null;

  const renderDocument = () => {
    const type = docType?.trim().toUpperCase();
    switch (type) {
      case "INSPEKSI":
        return <STInspeksi data={data} />;
      case "SKP":
        return <STskp data={data} />;
      case "SURVAILLANCE": 
        return <STDocument data={data} />;
      default:
        console.warn("Tipe tidak dikenal, menggunakan STDocument default");
        return <STDocument data={data} />;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="70vw" h="90vh">
        <ModalHeader>Preview Surat Tugas - {docType}</ModalHeader>
        <ModalCloseButton />
        <ModalBody p={0}>
          <PDFViewer width="100%" height="100%">
            {renderDocument()}
          </PDFViewer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CetakST;
